import type { ReactNode } from "react";
import type { FormatOptionLabelMeta } from "react-select";
import type { BaseOption } from "shared/components";
import type { SenderRecommendation } from "../hooks/useRecommendedSender";

export type SenderOption = BaseOption & { menuLabel?: ReactNode };

export const formatSenderOptionLabel = (
  option: unknown,
  meta: FormatOptionLabelMeta<unknown>
): ReactNode => {
  const { label, menuLabel } = option as SenderOption;
  return meta.context === "menu" && menuLabel ? menuLabel : label;
};

export const senderMenuWidth = (recommendation: SenderRecommendation | null) =>
  recommendation ? "372px" : undefined;
